import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Warranty } from '../Models/Warranty';
import { WarrantyPartsReplaced } from '../Models/WarrantyPartsReplaced';
import { WarrantyLabor } from '../Models/WarrantyLabor';
import { WarrantyPhoto } from '../Models/WarrantyPhoto';

class WarrantyApi {
  static getWarranty(id: string) {
    return axios.get<Warranty>(
      `${API_URL}/api/warranty/${id}`,
      getAuthHeader()
    );
  }
  static getWarranties(userId: number) {
    return axios.get<Warranty[]>(
      `${API_URL}/api/warranty/list/${userId}`,
      getAuthHeader()
    );
  }
  static getWarrantyPartsReplaceds(warrantyId: string) {
    return axios.get<WarrantyPartsReplaced[]>(
      `${API_URL}/api/warranty/parts/${warrantyId}`,
      getAuthHeader()
    );
  }
  static getWarrantyLabors(warrantyId: string) {
    return axios.get<WarrantyLabor[]>(
      `${API_URL}/api/warranty/labors/${warrantyId}`,
      getAuthHeader()
    );
  }
  static getWarrantyPhotos(warrantyId: string) {
    return axios.get<WarrantyPhoto[]>(
      `${API_URL}/api/warranty/photos/${warrantyId}`,
      getAuthHeader()
    );
  }
  static addUpdateWarranty(request: Warranty) {
    return axios.post<ResponseModel>(`${API_URL}/api/warranty`, request);
  }
  static deleteWarranty(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/warranty/${id}`,
      getAuthHeader()
    );
  }
  static deleteWarrantyPart(partId: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/warranty/part/${partId}`,
      getAuthHeader()
    );
  }
  static deleteWarrantyLabor(laborId: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/warranty/labor/${laborId}`,
      getAuthHeader()
    );
  }
  static deleteWarrantyPhoto(photoId: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/warranty/photo/${photoId}`,
      getAuthHeader()
    );
  }
  static addUpdateWarrantyPart(request: WarrantyPartsReplaced) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/warranty/warrantypart`,
      request
    );
  }
  static addUpdateWarrantyLabor(request: WarrantyLabor) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/warranty/warrantylabor`,
      request
    );
  }
  static addUpdateWarrantyPhoto(request: WarrantyPhoto) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/warranty/warrantyphoto`,
      request
    );
  }
  static uploadWarrantyImage(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/warranty/imageupload`,
      request
    );
  }
  static submitWarrantyRequest(warrantyId: string) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/warranty/submitrequest/${warrantyId}`,
      null
    );
  }
}

export default WarrantyApi;
